import {
	createContext,
	useContext
} from 'react';

export const ModelFormContext = createContext({setActiveRecord: () => {}});
export const useModelForm = () => {
	const modelForm = useContext(ModelFormContext);
	return modelForm;
};
export const ModelFormProvider = ModelFormContext.Provider;
export default ModelFormProvider;